// third-party
import { FormattedMessage } from "react-intl";

// assets
import { IconDashboard, IconDeviceAnalytics } from "@tabler/icons";

const icons = {
  IconDashboard,
  IconDeviceAnalytics,
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const Pricing = {
  id: "Pricing",
  title: <FormattedMessage id="language-pricing" />,
  icon: icons.IconDashboard,
  type: "group",
  children: [
    {
      id: "pricing-list2",
      title: <FormattedMessage id="pricing-tool" />,
      type: "item",
      url: "/pricing/pricing-tool",
      icon: PricingIcon,
      breadcrumbs: false,
    },
    {
      id: "pricing-deals-tool",
      title: <FormattedMessage id="pricing-deals-tool" />,
      type: "item",
      url: "/pricing/deals-tool",
      icon: DealsIcon,
      breadcrumbs: false,
    },
    {
      id: "pricing-glossary",
      title: <FormattedMessage id="glossary" />,
      type: "item",
      url: "/pricing/pricing-tool/glossary",
      icon: GlossaryIcon,
      breadcrumbs: false,
    },
    {
      id: "pricing-launch-simulator",
      title: "Simulador",
      type: "item",
      url: "/pricing/launch-simulator",
      icon: LaunchSimulatorIcon,
      breadcrumbs: false,
    },
  ],
};

export default Pricing;

function PricingIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>pricing</title>

      <path
        d="M2.10939 2.11876C2.30372 1.92218 2.53522 1.76624 2.79041 1.66001C3.0456 1.55378 3.31938 1.49939 3.59579 1.50001H9.35814C9.73613 1.50071 10.0986 1.65045 10.3669 1.91672L21.8864 13.4339C22.2795 13.8278 22.5002 14.3615 22.5002 14.918C22.5002 15.4744 22.2795 16.0082 21.8864 16.402L16.402 21.8864C16.0081 22.2797 15.4742 22.5005 14.9175 22.5005C14.3609 22.5005 13.827 22.2797 13.433 21.8864L1.91814 10.3739C1.65133 10.1061 1.50106 9.74369 1.50001 9.36563V3.60001C1.49831 3.32503 1.5513 3.05247 1.65592 2.79817C1.76053 2.54388 1.91468 2.31292 2.10939 2.11876ZM6.00001 7.5C6.29668 7.5 6.58669 7.41203 6.83337 7.24721C7.08004 7.08239 7.2723 6.84812 7.38583 6.57403C7.49936 6.29994 7.52907 5.99834 7.47119 5.70737C7.41331 5.4164 7.27045 5.14912 7.06067 4.93934C6.85089 4.72957 6.58362 4.5867 6.29265 4.52883C6.00167 4.47095 5.70008 4.50065 5.42599 4.61419C5.1519 4.72772 4.91763 4.91998 4.75281 5.16665C4.58798 5.41332 4.50001 5.70333 4.50001 6C4.50001 6.39783 4.65805 6.77936 4.93935 7.06067C5.22066 7.34197 5.60219 7.5 6.00001 7.5Z"
        fill="currentColor"
      />
    </svg>
  );
}

function GlossaryIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>glossary</title>

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.14282 19.9286V3.85714C2.14282 2.83417 2.5492 1.85309 3.27255 1.12973C3.99591 0.406376 4.97699 0 5.99996 0L18 0C19.0229 0 20.004 0.406376 20.7274 1.12973C21.4507 1.85309 21.8571 2.83417 21.8571 3.85714V17.1429C21.8571 17.4839 21.7216 17.8109 21.4805 18.052C21.2394 18.2931 20.9124 18.4286 20.5714 18.4286H20.1428V21.4286H20.5714C20.9124 21.4286 21.2394 21.564 21.4805 21.8051C21.7216 22.0463 21.8571 22.3733 21.8571 22.7143C21.8571 23.0553 21.7216 23.3823 21.4805 23.6234C21.2394 23.8645 20.9124 24 20.5714 24H6.21425C5.13444 24 4.09886 23.571 3.33532 22.8075C2.57178 22.044 2.14282 21.0084 2.14282 19.9286ZM17.5714 18.4286H6.21425C5.81643 18.4286 5.4349 18.5866 5.15359 18.8679C4.87229 19.1492 4.71425 19.5307 4.71425 19.9286C4.71425 20.3264 4.87229 20.7079 5.15359 20.9892C5.4349 21.2705 5.81643 21.4286 6.21425 21.4286H17.5714V18.4286ZM18.5314 8.18057C18.4591 8.04107 18.3499 7.92412 18.2157 7.8425C18.0814 7.76087 17.9274 7.7177 17.7703 7.71771H13.8034C13.5761 7.71771 13.358 7.80802 13.1973 7.96877C13.0366 8.12951 12.9462 8.34753 12.9462 8.57486C12.9462 8.80219 13.0366 9.0202 13.1973 9.18095C13.358 9.34169 13.5761 9.432 13.8034 9.432H16.1142L12.8554 14.0331C12.7645 14.1614 12.7107 14.3122 12.6998 14.469C12.6889 14.6259 12.7213 14.7827 12.7935 14.9223C12.8657 15.0619 12.9749 15.179 13.1092 15.2607C13.2435 15.3425 13.3976 15.3857 13.5548 15.3857H18.0188C18.2461 15.3857 18.4642 15.2954 18.6249 15.1347C18.7857 14.9739 18.876 14.7559 18.876 14.5286C18.876 14.3012 18.7857 14.0832 18.6249 13.9225C18.4642 13.7617 18.2461 13.6714 18.0188 13.6714H15.2125L18.4697 9.07029C18.5609 8.94209 18.6151 8.79126 18.6262 8.63433C18.6374 8.4774 18.6035 8.32041 18.5314 8.18057ZM9.96854 4.50857C9.86535 4.20157 9.66837 3.93471 9.40539 3.74566C9.14241 3.55661 8.8267 3.45491 8.50282 3.45491C8.17894 3.45491 7.86324 3.55661 7.60025 3.74566C7.33727 3.93471 7.14029 4.20157 7.03711 4.50857L5.87654 7.98857L5.86454 8.02629L5.20797 9.99086C5.17228 10.0978 5.15801 10.2107 5.16597 10.3232C5.17392 10.4356 5.20395 10.5454 5.25433 10.6462C5.30471 10.7471 5.37447 10.837 5.45961 10.9109C5.54474 10.9848 5.6436 11.0412 5.75054 11.0769C5.9665 11.1489 6.20224 11.1322 6.40591 11.0305C6.50675 10.9801 6.59668 10.9104 6.67057 10.8252C6.74446 10.7401 6.80085 10.6412 6.83654 10.5343L7.29939 9.13543H9.70282L10.1691 10.5343C10.2412 10.75 10.396 10.9283 10.5995 11.0299C10.803 11.1315 11.0385 11.1481 11.2543 11.076C11.47 11.0039 11.6483 10.8491 11.7498 10.6456C11.8514 10.4421 11.868 10.2066 11.796 9.99086L11.1411 8.02629L11.1274 7.98857L9.96854 4.50857ZM7.86854 7.41943L8.49939 5.53029L9.12854 7.41943H7.86854Z"
        fill="currentColor"
      />
    </svg>
  );
}

function LaunchSimulatorIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>launch-simulator</title>
      <path
        d="M13.13 22.19L11.5 18.36C13.07 17.78 14.54 17 15.9 16.09L13.13 22.19ZM5.64 12.5L1.81 10.87L7.91 8.1C7 9.46 6.22 10.93 5.64 12.5ZM21.61 2.39C21.61 2.39 16.66 0.269 11 5.93C8.81 8.12 7.5 10.53 6.65 12.64C6.37 13.39 6.56 14.21 7.11 14.77L9.24 16.89C9.79 17.45 10.61 17.63 11.36 17.35C13.5 16.53 15.88 15.19 18.07 13C23.73 7.34 21.61 2.39 21.61 2.39ZM14.54 9.46C13.76 8.68 13.76 7.41 14.54 6.63C15.32 5.85 16.59 5.85 17.37 6.63C18.14 7.41 18.15 8.68 17.37 9.46C16.59 10.24 15.32 10.24 14.54 9.46ZM8.88 16.53L7.47 15.12L8.88 16.53ZM6.24 22L9.88 18.36C9.54 18.27 9.21 18.12 8.91 17.91L5.09 21.73C4.69 22.12 4.69 22.75 5.09 23.15C5.48 23.54 6.11 23.54 6.5 23.15L10.27 19.38C10.06 19.08 9.91 18.74 9.82 18.41L6.24 22Z"
        fill="currentColor"
      />
    </svg>
  );
}

function DealsIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>deals</title>
      <path
        d="M4 4.5H20C20.3978 4.5 20.7792 4.65815 21.0605 4.93945C21.3419 5.22076 21.5 5.60218 21.5 6V9.55078C21.0233 9.64811 20.5816 9.88324 20.2324 10.2324C19.7636 10.7013 19.5 11.337 19.5 12C19.5 12.663 19.7636 13.2987 20.2324 13.7676C20.5816 14.1167 21.0234 14.3509 21.5 14.4482V18C21.5 18.3978 21.3419 18.7792 21.0605 19.0605C20.7792 19.3419 20.3978 19.5 20 19.5H4C3.60218 19.5 3.22076 19.3419 2.93945 19.0605C2.65815 18.7792 2.5 18.3978 2.5 18V14.4482C2.97663 14.3509 3.41845 14.1167 3.76758 13.7676C4.23642 13.2987 4.5 12.663 4.5 12C4.5 11.337 4.23642 10.7013 3.76758 10.2324C3.4184 9.88324 2.9767 9.64811 2.5 9.55078V6C2.5 5.60218 2.65815 5.22076 2.93945 4.93945C3.22076 4.65815 3.60218 4.5 4 4.5ZM6.29297 15.5L8.5 17.707L17.707 8.5L15.5 6.29297L6.29297 15.5ZM15.1904 12.9199C14.5884 12.9199 14.0107 13.1593 13.585 13.585C13.1593 14.0107 12.9199 14.5884 12.9199 15.1904C12.9202 16.4464 13.9344 17.46 15.1904 17.46C15.7923 17.4598 16.3693 17.2205 16.7949 16.7949C17.2205 16.3693 17.4598 15.7923 17.46 15.1904C17.46 13.9344 16.4464 12.9202 15.1904 12.9199ZM8.80957 6.54004C8.20768 6.54015 7.63068 6.77947 7.20508 7.20508C6.77947 7.63068 6.54015 8.20768 6.54004 8.80957C6.54004 10.0656 7.55363 11.0798 8.80957 11.0801C9.41161 11.0801 9.98933 10.8407 10.415 10.415C10.8407 9.98933 11.0801 9.41161 11.0801 8.80957C11.0798 7.55363 10.0656 6.54004 8.80957 6.54004Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </svg>
  );
}
